import * as css from './button-actions.scss';
import { Button, Link, View } from '../elements';
import { translate } from '../../services/i18n/i18n';
import { translationKeys } from '../../constants/constants';
import { DataHook } from '../../constants/data-hooks';
import { BaseComponentProps, Theme } from '../../types';
import { savePolicy } from '../../services/consent-policy-manager/consent-policy-manager';
import { renderComponent } from '../../utils/utils';
import { SettingsComponent } from '../settings/settings.component';

interface Props extends BaseComponentProps {
  theme: Theme;
  declineAll?: boolean;
  onCloseClicked: () => void;
}

export const ButtonActions = (props: Props) => {
  const onAcceptClick = async () => {
    void savePolicy({
      policy: {
        essential: true,
        functional: true,
        analytics: true,
        advertising: true,
      },
      successCallback: props.onCloseClicked,
      errorCallback: props.onCloseClicked,
    });
  };

  const onDeclineClick = async () => {
    void savePolicy({
      policy: {
        essential: true,
        functional: false,
        analytics: false,
        advertising: false,
      },
      successCallback: props.onCloseClicked,
      errorCallback: props.onCloseClicked,
    });
  };

  const onSettingsClicked = async () => {
    await renderComponent(new SettingsComponent());
  };

  const { declineAll, theme } = props;
  const buttonsContainer = View({
    className: `${css.buttonActions} ${declineAll ? css.declineAll : ''}`,
  });
  const settingsButtonConstructor = declineAll ? Link : Button;
  let settingsButtonConfig = {
    text: translate(translationKeys.openSettingsButton),
    dataHook: DataHook.settingsButton,
    onClick: onSettingsClicked,
    className: declineAll ? css.settingsLink : css.settingsButton,
  };
  if (!declineAll) {
    settingsButtonConfig = {
      ...settingsButtonConfig,
      // @ts-ignore
      theme,
      secondary: true,
    };
  } else {
    // @ts-ignore
    settingsButtonConfig.href = '#';
  }
  // @ts-ignore
  const settingsButton = settingsButtonConstructor(settingsButtonConfig);

  buttonsContainer.appendChild(settingsButton);

  if (declineAll) {
    buttonsContainer.appendChild(
      Button({
        dataHook: DataHook.declineAllButton,
        text: translate(translationKeys.declineCookiesButton),
        theme,
        className: css.declineButton,
        onClick: onDeclineClick,
        secondary: true,
      }),
    );
  }

  buttonsContainer.appendChild(
    Button({
      dataHook: DataHook.acceptPolicyButton,
      className: css.acceptButton,
      text: translate(translationKeys.acceptCookiesButton),
      theme: theme === Theme.dark ? Theme.light : Theme.dark,
      onClick: onAcceptClick,
    }),
  );
  return buttonsContainer;
};
